import { format, setYear } from "date-fns";
import React, { useEffect, useState } from "react";
import Input from "./Input";
import Dropdown from "./Dropdown";
import Checkbox from "./Checkbox";
import MyDropzone from "./MyDropzone";
import ModalComponent from "./Modal";
import { randomString } from "../common";
import axios from 'axios'
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setCurrenDeclaration } from "../redux/eoiReducer";
import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../firebase-config";
import { clearPageMessage, showLoadingMessage, showSuccessMessage, showWarningMessage } from "../successMessage";
import { getDeclarationSaveErrorMessage } from "../declarationSaveError";

const DisplayDeclaration = ({ currentDeclaration, fetchDeclaration, isAdmin, onActionMessage, onSaveComplete, onEditStart, isEditing = true, hideFooterActions = false }) => {


    // const [page, setPage] = useState(0)
    const [errors, setErrors] = useState([])
    const [errorMessage, setErrorMessage] = useState('')
    const [loading, setLoading] = useState(false)
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)



    const [statementTraningNumber, setStatementTraningNumber] = useState('')
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [delivery, setDelivery] = useState('')
    const [dob, setDob] = useState('')

    // const [signatureString, setSignatureString] = useState('')

    const [declarationDate, setDeclarationDate] = useState(format(new Date(), 'dd-MM-yyyy'))
    // const signatureRef = useRef()


    const dispatch = useDispatch()

    const updateDropdownValue = val => ({ label: val, value: val })


    useEffect(() => {
        if (currentDeclaration) {
            console.log('currentDeclaration', currentDeclaration.id)
            resetDoc()
        }
    }, [currentDeclaration])



    const resetDoc = () => {
        const data = currentDeclaration.data

        setFirstName(data.firstName)
        setLastName(data.lastName)
        setDelivery(data.delivery)
        setDob(data.dob)
        setStatementTraningNumber(data.statementTraningNumber)
        setDeclarationDate(data.declarationDate)
    }


    const handleUpdate = async () => {
        const id = currentDeclaration.id

        try {
            setLoading(true)
            showLoadingMessage('Saving Declaration')
            await axios.post('https://australia-southeast1-upskillinstitute-au.cloudfunctions.net/fillDeclarationPdf', {
                // const resp = await axios.post('http://127.0.0.1:5001/upskillinstitute-au/australia-southeast1/fillDeclarationPdf', {
                data: {
                    ...currentDeclaration.data,
                    trainerId: currentDeclaration.data.trainerId,
                    id,
                    firstName,
                    lastName,
                    delivery,
                    dob,
                    statementTraningNumber,
                    declarationDate,
                    signature: currentDeclaration.data.signature
                }
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                }
            })
            setLoading(false)
            fetchDeclaration()
            onSaveComplete && onSaveComplete()
            if (onActionMessage) {
                onActionMessage('Declaration has been updated', true)
            } else {
                showSuccessMessage('Declaration has been updated')
            }
            // window.open(resp.data)
        } catch (e) {
            setLoading(false)
            clearPageMessage()
            const saveErrorMessage = getDeclarationSaveErrorMessage(e)
            if (onActionMessage) {
                onActionMessage(saveErrorMessage, false)
            } else {
                toast.error(saveErrorMessage, { position: 'top-center' })
            }

            console.error('e', e)
        }

    }


    if (!currentDeclaration) {
        return <></>
    }

    const handleDelete = async () => {
        showLoadingMessage('Deleting Declaration')
        try {
            setLoading(true)
            await deleteDoc(doc(db, 'declaration', showDeleteConfirmation))
            setShowDeleteConfirmation(false)
            dispatch(setCurrenDeclaration())
            fetchDeclaration()
            showSuccessMessage('Declaration deleted successfully')
        } catch (error) {
            clearPageMessage()
            showWarningMessage('Declaration could not be deleted. Please try again.')
        } finally {
            setLoading(false)
        }
    }

    return (<div className="contentBlock">

        <div className="formWrapperInContentBlock">


            <Input readOnly={!isEditing} onFocus={() => !isEditing && onEditStart?.()} type={'text'} errorMessage={errors.includes('delivery') && errors.length === 1 && errorMessage} errors={errors} name={'delivery'} value={delivery} setValue={setDelivery} label={'Delivery'} />
            <label className='fieldHeading'>Applicant's Name</label>
            <div className='flexrow'>
                <Input readOnly={!isEditing} onFocus={() => !isEditing && onEditStart?.()} type={'text'} errorMessage={errors.includes('firstName') && errors.length === 1 && errorMessage} errors={errors} name={'firstName'} value={firstName} setValue={setFirstName} label={'First Name'} />
                <Input readOnly={!isEditing} onFocus={() => !isEditing && onEditStart?.()} type={'text'} errorMessage={errors.includes('lastName') && errors.length === 1 && errorMessage} errors={errors} name={'lastName'} value={lastName} setValue={setLastName} label={'Last Name'} />
            </div>

            <Input readOnly={!isEditing} onFocus={() => !isEditing && onEditStart?.()} type={'text'} errorMessage={errors.includes('dob') && errors.length === 1 && errorMessage} errors={errors} placeholder={'DD/MM/YYYY'} name={'dob'} value={dob} setValue={setDob} label={'Date of Birth (dd/mm/yyyy)'} />

            {/* <label className='fieldHeading'> Applicant's Signature </label>
            <SignatureCanvas penColor='black'
                ref={signatureRef}
                canvasProps={{ width: 500, height: 200, className: `sigCanvas ${errors.includes('signature') ? 'error' : ''}` }} />
            <div>
                <button style={{ color: '#FF7100', background: 'white', border: '1px solid #FF7100' }} onClick={() => signatureRef.current.clear()}>Clear</button>
            </div> */}

            <Input readOnly={!isEditing} onFocus={() => !isEditing && onEditStart?.()} type={'text'} placeholder={'DD-MM-YYY'} errorMessage={errors.includes('declarationDate') && errors.length === 1 && errorMessage} errors={errors} name={'declarationDate'} value={declarationDate} setValue={setDeclarationDate} label={'Date of Declaration'} />

            <Input readOnly={!isEditing} onFocus={() => !isEditing && onEditStart?.()} type={'text'} errorMessage={errors.includes('statementTraningNumber') && errors.length === 1 && errorMessage} errors={errors} name={'statementTraningNumber'} value={statementTraningNumber} setValue={setStatementTraningNumber} label={'SOT Number'} />


            <ModalComponent showModal={!!showDeleteConfirmation} setShowModal={setShowDeleteConfirmation}>
                <> <h2 style={{ textAlign: 'center' }}>Are you sure you want to delete?</h2>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'center' }}>
                        <button disabled={loading} onClick={handleDelete}>{loading ? 'Loading...' : 'Confirm'}</button>
                        <button style={{ marginLeft: '40px', display: 'flex', color: '#FF7100', background: 'white', border: '1px solid #FF7100' }} onClick={() => setShowDeleteConfirmation(false)}>Close</button>
                    </div>
                </>
            </ModalComponent>

            <div style={{ display: hideFooterActions ? 'none' : 'flex', marginBottom: hideFooterActions ? 0 : '60px' }}>
                <button id='student-declaration-update-action' disabled={loading} onClick={handleUpdate}>{loading ? 'Loading...' : 'Update'}</button>
                {isAdmin && <button id='student-declaration-delete-action' style={{ marginLeft: '40px', display: 'flex', color: '#FF7100', background: 'white', border: '1px solid #FF7100' }} onClick={() => setShowDeleteConfirmation(currentDeclaration.id)}>Delete</button>}
            </div>

        </div>
    </div >)
}

export default DisplayDeclaration
